import React from 'react'
import { VITALS_READ, VITALS_WRITE } from '../../../../utils/roles'
import RenderOnRole from '../../../../components/RenderOnRole'
import Vitals from '../Vitals'

const VitalsDental = () => {
  return (
    <RenderOnRole
      roles={[VITALS_READ, VITALS_WRITE]}
      element={<Vitals intent='vitalsDental' />}
    />
  )
}

export default VitalsDental
